import type { CSSProperties } from 'react';
import styles from './Skeleton.module.css';

interface SkeletonBaseProps {
  className?: string;
  style?: CSSProperties;
}

interface SkeletonLineProps extends SkeletonBaseProps {
  width?: string | number;
}

interface SkeletonBlockProps extends SkeletonBaseProps {
  width?: string | number;
  height?: string | number;
}

interface SkeletonCircleProps extends SkeletonBaseProps {
  size?: string | number;
}

function SkeletonLine({ width = '100%', className, style }: SkeletonLineProps) {
  return (
    <span
      className={[styles.base, styles.line, className].filter(Boolean).join(' ')}
      style={{ width, ...style }}
      aria-hidden="true"
      data-primitive="Skeleton.Line"
    />
  );
}

function SkeletonBlock({ width = '100%', height = 80, className, style }: SkeletonBlockProps) {
  return (
    <span
      className={[styles.base, styles.block, className].filter(Boolean).join(' ')}
      style={{ width, height, ...style }}
      aria-hidden="true"
      data-primitive="Skeleton.Block"
    />
  );
}

function SkeletonCircle({ size = 40, className, style }: SkeletonCircleProps) {
  return (
    <span
      className={[styles.base, styles.circle, className].filter(Boolean).join(' ')}
      style={{ width: size, height: size, ...style }}
      aria-hidden="true"
      data-primitive="Skeleton.Circle"
    />
  );
}

export const Skeleton = {
  Line: SkeletonLine,
  Block: SkeletonBlock,
  Circle: SkeletonCircle,
};
